import { orderBy } from 'lodash';
import { getABData } from '../../../util/ABUtil';

export const TM_ASSOCIATED_ACCOUNTS_WIDGET_CS =
  'TM_ASSOCIATED_ACCOUNTS_WIDGET_CS';
export const TM_ASSOCIATED_ACCOUNTS_WIDGET_CC =
  'TM_ASSOCIATED_ACCOUNTS_WIDGET_CC';
export const TM_ASSOCIATED_ACCOUNTS_WIDGET_FD =
  'TM_ASSOCIATED_ACCOUNTS_WIDGET_FD';
export const TM_ASSOCIATED_ACCOUNTS_WIDGET_L =
  'TM_ASSOCIATED_ACCOUNTS_WIDGET_L';

export const TM_TRANSACTION_DETAILS_WIDGET = 'TM_TRANSACTION_DETAILS_WIDGET';
export const TM_ALERT_DETAILS_WIDGET = 'TM_ALERT_DETAILS_WIDGET';
export const TM_CUSTOMER_ACTIVITY_WIDGET = 'TM_CUSTOMER_ACTIVITY_WIDGET';
export const TM_ADDITION_INFO_WIDGET = 'TM_ADDITION_INFO_WIDGET';

// get specific setting for a widgetId
export const parseSettings = (settingsData, widgetId) => {
  let selectedSettings = null;
  if (settingsData) {
    if (Array.isArray(settingsData)) {
      settingsData.forEach((uiWidgetGroup) => {
        if (uiWidgetGroup) {
          const { widgets } = uiWidgetGroup;
          if (Array.isArray(widgets)) {
            widgets.forEach((currentWidget) => {
              if (currentWidget.widgetId === widgetId) {
                selectedSettings = currentWidget.widgetConfig;
              }
            });
          }
        }
      });
    }
  }

  return selectedSettings;
};

// get widget ids in order
export const parseWidgetOrder = (settingsData, widgetGroupId) => {
  let sequencedWidgetIds = null;
  if (settingsData) {
    if (Array.isArray(settingsData)) {
      settingsData.forEach((uiWidgetGroup) => {
        if (uiWidgetGroup) {
          if (uiWidgetGroup.widgetGroupId === widgetGroupId) {
            const { widgets } = uiWidgetGroup;
            sequencedWidgetIds = orderBy(widgets, ['widgetIndex'], ['asc'])
              .map((currentWidget) => {
                if (currentWidget) {
                  return currentWidget.widgetId;
                }

                return null;
              })
              .filter((item) => item !== null);
          }
        }
      });
    }
  }

  return sequencedWidgetIds;
};

// as the name implies
export const parseWidgetGroupsTabList = (settingsData) => {
  let tabList = null;
  if (settingsData) {
    if (Array.isArray(settingsData)) {
      tabList = orderBy(settingsData, ['widgetGroupIndex'], ['asc'])
        .map((currentWidgetGroup) => {
          return returnWidgetGroupName(currentWidgetGroup.widgetGroupId);
        })
        .filter((item) => item !== null);
    }
  }

  return tabList;
};

// as the name implies
export const parseWidgetGroupsIds = (settingsData) => {
  let tabList = null;
  if (settingsData) {
    if (Array.isArray(settingsData)) {
      tabList = orderBy(settingsData, ['widgetGroupIndex'], ['asc'])
        .map((currentWidgetGroup) => {
          return currentWidgetGroup.widgetGroupId;
        })
        .filter((item) => item !== null);
    }
  }

  return tabList;
};

export const parseSortItemsForAlertDetails = (settings) => {
  console.log('settings', settings);
  if (settings) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc']);
    const sortableItems = sortedSettings
      .map((currentColumn, currentColumnIndex) => {
        const columnItems = currentColumn?.columnDetail
          ?.map((currentItem) => {
            if (currentItem?.sortEnabled) {
              return {
                label: currentItem?.itemLabel,
                columnName: currentItem?.itemName,
                type: 'STRING'
              };
            } else {
              return null;
            }
          })
          .filter((o) => o !== null);

        if (columnItems?.length > 0) {
          // return column group
          return {
            key: `${currentColumnIndex}`,
            columnGroup: currentColumn?.columnName,
            columnGroupIndex: currentColumnIndex,
            columnItems: columnItems
          };
        } else {
          return null;
        }
      })
      ?.filter((o) => o !== null);

    return sortableItems || [];
  }

  return [];
};

export const parseFilterItemsForAlertDetails = (settings) => {
  if (settings) {
    const sortedSettings = orderBy(settings, ['columnIndex'], ['asc']);

    let filterableItems = [];

    sortedSettings.forEach((currentColumn, currentColumnIndex) => {
      const columnItems = currentColumn?.columnDetail
        ?.map((currentItem) => {
          if (currentItem?.filterEnabled) {
            return {
              columnLabel: currentItem?.itemLabel,
              columnName: currentItem?.itemName
            };
          } else {
            return null;
          }
        })
        .filter((o) => o !== null);

      if (columnItems?.length > 0) {
        filterableItems = [...filterableItems, ...columnItems];
      }
    });

    return filterableItems;
  }

  return [];
};

export const parseColumnsForC2A = (settings) => {
  let C2CAableHeaderBasedOnSettings = null;
  if (Array.isArray(settings)) {
    const sortedAssociatedCustomersSettings = orderBy(
      settings.filter((o) => o !== null),
      ['columnIndex'],
      ['asc']
    ).filter((item) => item.columnVisibility);
    C2CAableHeaderBasedOnSettings = sortedAssociatedCustomersSettings
      .map((currentColumn) => {
        if (currentColumn) {
          const { columnDetail } = currentColumn;

          if (Array.isArray(columnDetail)) {
            if (columnDetail.length > 1) {
              return {
                ...returnColumnMetadataForC2A(columnDetail[0]),
                subColumns: columnDetail
                  .map((item, itemIndex) => {
                    if (itemIndex !== 0) {
                      return returnColumnMetadataForC2A(item);
                    }

                    return null;
                  })
                  .filter((item) => item !== null)
              };
            }

            return returnColumnMetadataForC2A(columnDetail[0]);
          }
        }

        return null;
      })
      .filter((o) => o !== null);
  }

  return C2CAableHeaderBasedOnSettings;
};

const returnColumnMetadataForAlertDetails = (item) => {
  if (item) {
    switch (item.itemName) {
      case 'alertId':
      case 'alertDate':
      case 'alertScore':
      case 'alertStatus':
      case 'closureDate':
        return {
          name: getABData(item.itemLabel),
          label: getABData(item.itemLabel),
          key: 'alertId'
        };

      default:
        return {
          name: item.itemLabel,
          label: item.itemLabel,
          key: item.itemName
        };
    }
  }
};

const returnColumnMetadataForC2A = (item) => {
  if (item) {
    switch (item.itemName) {
      case 'accountId':
        return {
          name: item.itemLabel,
          key: 'account_id'
        };

      case 'cardNumber':
        return {
          name: item.itemLabel,
          key: 'card_number'
        };

      case 'loanGroup':
        return {
          name: item.itemLabel,
          key: 'loan_group'
        };

      case 'loanType':
        return {
          name: item.itemLabel,
          key: 'loan_type'
        };

      case 'loanPurposeCode':
        return {
          name: item.itemLabel,
          key: 'loan_purpose_code'
        };

      case 'numberOfRepayments':
        return {
          name: item.itemLabel,
          key: 'number_of_repayments'
        };

      case 'loanDisbursementDate':
        return {
          name: item.itemLabel,
          key: 'loan_disbursement_date'
        };

      case 'fdReceiptNumber':
        return {
          name: item.itemLabel,
          key: 'fd_receipt_number'
        };

      case 'fdPlacementDate':
        return {
          name: item.itemLabel,
          key: 'fd_placement_date'
        };

      case 'fdMaturityDate':
        return {
          name: item.itemLabel,
          key: 'fd_maturity_date'
        };

      case 'fdWithdrawalDate':
        return {
          name: item.itemLabel,
          key: 'fd_withdrawal_date'
        };

      case 'accountCurrency':
        return {
          name: item.itemLabel,
          key: 'account_currency'
        };

      case 'accountName':
        return {
          name: item.itemLabel,
          key: 'account_name'
        };

      case 'c2aRelationship':
        return {
          name: item.itemLabel,
          key: 'c2a_relationship'
        };

      case 'openDate':
        return {
          name: item.itemLabel,
          key: 'account_open_date'
        };

      case 'accountClosedDate':
        return {
          name: item.itemLabel,
          key: 'account_closed_date'
        };

      case 'accountStatus':
        return {
          name: item.itemLabel,
          key: 'account_status'
        };

      case 'balance':
        return {
          name: item.itemLabel,
          key: 'balance',
          formatNumeric: true,
          isMoney: true,
          showOriginalOnHover: true
        };

      case 'accountDrAvgBalance':
        return {
          name: item.itemLabel,
          key: 'account_dr_avg_balance',
          formatNumeric: true,
          isMoney: true,
          showOriginalOnHover: true
        };

      case 'accountCrAvgBalance':
        return {
          name: item.itemLabel,
          key: 'account_cr_avg_balance',
          formatNumeric: true,
          isMoney: true,
          showOriginalOnHover: true
        };

      case 'creditLimit':
        return {
          name: item.itemLabel,
          key: 'credit_limit',
          formatNumeric: true,
          isMoney: true,
          showOriginalOnHover: true
        };

      case 'outstanding_loan_balance':
        return {
          name: item.itemLabel,
          key: 'outstanding_loan_balance',
          formatNumeric: true,
          isMoney: true,
          showOriginalOnHover: true
        };

      case 'loan_installment_amount':
        return {
          name: item.itemLabel,
          key: 'loan_installment_amount',
          formatNumeric: true,
          isMoney: true,
          showOriginalOnHover: true
        };

      default:
        return {
          name: item.itemLabel,
          key: item.itemName
        };
    }
  }

  return null;
};

const returnWidgetGroupName = (widgetGroupId) => {
  switch (widgetGroupId) {
    case 'TM_ALERT_DETAILS_GROUP':
      return 'Alert Details';

    case 'TM_CUSTOMER_ACTIVITY_GROUP':
      return 'Customer Activity';

    case 'TM_CUSTOMER_DETAILS_GROUP':
      return 'Customer Details';

    case 'TM_TRANSACTION_DETAILS_GROUP':
      return 'Transaction Details';

    default:
      return null;
  }
};
